import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";
import { notifyPermissionDenied } from "../handleCallableError";

export const resetMemberPassword = async ({
  uid,
  operatingUnitId,
  password,
  requestedApp,
}) => {
  try {
    const fn = httpsCallable(functions, "resetMemberPasswordV2");
    const result = await fn({
      uid,
      operatingUnitId,
      password,
      confirm: true,
      requestedApp,
    });
    return result.data;
  } catch (error) {
    notifyPermissionDenied(error);
    throw error;
  }
};
